/*
* @Author: babysoft08
* @Date:   2025-05-30 14:06:55
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-05-30 16:46:35
*/
import { useAuthContext } from '../context/authContext';
const useAuth = useAuthContext;
export default useAuth;